export default "__VITE_ASSET__Hcul40DU__"